export default function OrnamentoDourado({ simbolo = "✦", className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-6 text-[var(--cor-dourado)] ${className}`} aria-hidden="true">
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-[var(--cor-dourado)]/60" />
      <span className="text-lg">{simbolo}</span>
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-[var(--cor-dourado)]/60" />
    </div>
  );
}
